import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import {
  Tabs, 
  TabList, 
  Tab,
} from '@pearsontechnology/aero-components';
import {
  PageActions,
  PageActionsLeft,
} from 'components/PageStyles';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import messages from './messages';
import { ProjectTabList, ProjectTab, ProjectDividerLine } from './styles';

function TabHeader(){
  const tabLabels = [
    { label: intl.formatMessage(messages.projects) },
    { label: intl.formatMessage(messages.classes) },
    { label: intl.formatMessage(messages.publications) },
  ];
  const history = useHistory();
  const [tabIndex, setTabIndex] = useState(null);

  useEffect(() => {
    if (history.location.pathname === '/courseware') {
      setTabIndex(0);
    }
    if (history.location.pathname === '/classes') {
      setTabIndex(1);
    }
    if (history.location.pathname === '/publications') {
      setTabIndex(2);
    }
  }, [history]);

  const setNavigation = (index) => {
    if(index === 0) { history.push("/courseware"); }
    if(index === 1) { history.push("/classes"); }
    if(index === 2) { history.push("/publications"); }
  };

  return (<PageActions>
    <PageActionsLeft as={ProjectDividerLine}>
      <Tabs
        tabSpacing={0}
        onChange={setNavigation}
        index={tabIndex}
      >
        <TabList as={ProjectTabList} >
          {tabLabels.map((tab) => (
            <Tab as={ProjectTab} key={tab.label}>{tab.label}</Tab>
          ))}
        </TabList>
      </Tabs>
    </PageActionsLeft>
  </PageActions>);
}
export default TabHeader;